import { render, staticRenderFns } from "./GroupHero.vue?vue&type=template&id=95d7f368&scoped=true"
import script from "./GroupHero.vue?vue&type=script&lang=js"
export * from "./GroupHero.vue?vue&type=script&lang=js"
import style0 from "./GroupHero.vue?vue&type=style&index=0&id=95d7f368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d7f368",
  null
  
)

export default component.exports